














































import TableCell from './TableCell.vue'

const ALIGNMENT_TYPES = ['left', 'right', 'center']

export default {
  components: {
    TableCell
  },
  props: {
    fullName: { type: String, required: true },
    email: { type: String, required: true },
    phone: { type: String, default: null },
    hideContactButtonText: {
      type: String,
      default() {
        return this.$t('marketPlace.actionCellContactInfo.hideContact')
      }
    },
    hSpan: { type: Number, default: 4 },
    alignment: {
      type: String,
      required: false,
      default: 'left',
      validator: value => ALIGNMENT_TYPES.includes(value)
    }
  },
  data() {
    return {
      showContact: false
    }
  },
  computed: {
    toggleButtonText() {
      return !this.showContact && this.slotHasContent()
        ? this.$t('marketPlace.actionCellContactInfo.showContact')
        : this.hideContactButtonText
    },
    tooltip() {
      return this.phone ? this.fullName + '<br>' + this.phone : this.fullName
    }
  },
  methods: {
    handleClickToggle() {
      this.showContact = !this.showContact
    },
    slotHasContent() {
      return Boolean(this.$slots.default)
    }
  }
}
